import React, { useState } from 'react';

const INTEREST_MAP = {
  education: 'Education',
  healthcare: 'Healthcare',
  community: 'Community Development',
  environment: 'Environmental',
  it: 'IT & Technology',
};

const AVAILABILITY_MAP = {
  weekdays: 'Weekdays',
  weekends: 'Weekends',
  flexible: 'Flexible',
};

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;700&family=DM+Sans:wght@300;400;500;600&display=swap');

.vf-page { font-family:'DM Sans',sans-serif; background:#f5f4f0; min-height:100vh; }

/* Hero */
.vf-hero {
  position:relative; overflow:hidden;
  padding:4rem 2rem 3.5rem;
  background:linear-gradient(135deg,#0b3d4a 0%,#134d5e 55%,#1a6474 100%);
}
.vf-orb { position:absolute;border-radius:50%;filter:blur(80px);opacity:.15;pointer-events:none; }
.vf-orb--a { width:480px;height:480px;background:radial-gradient(circle,#e67e22,transparent);top:-120px;right:-80px; }
.vf-orb--b { width:320px;height:320px;background:radial-gradient(circle,#2196a4,transparent);bottom:-80px;left:-60px; }
.vf-hero-inner { position:relative;z-index:1;max-width:740px;margin:0 auto;text-align:center; }
.vf-badge { display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.2);color:rgba(255,255,255,.88);font-size:.75rem;letter-spacing:.08em;padding:5px 14px;border-radius:999px;margin-bottom:1.25rem; }
.vf-bdot { width:7px;height:7px;background:#f39c12;border-radius:50%;animation:vfPulse 2s ease-in-out infinite;flex-shrink:0; }
@keyframes vfPulse { 0%,100%{opacity:1;transform:scale(1)}50%{opacity:.5;transform:scale(1.5)} }
.vf-h1 { font-family:'Playfair Display',Georgia,serif;font-size:clamp(2rem,5vw,3.2rem);font-weight:700;color:#fff;line-height:1.15;margin:0 0 1rem; }
.vf-gold { background:linear-gradient(90deg,#f39c12,#e67e22);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text; }
.vf-hero-sub { font-size:1rem;color:rgba(255,255,255,.68);line-height:1.7;max-width:54ch;margin:0 auto; }

/* Body */
.vf-body { max-width:1100px;margin:0 auto;padding:3.5rem 2rem 5rem; }
.vf-grid { display:grid;grid-template-columns:1fr 320px;gap:2.5rem;align-items:start; }

/* Form card */
.vf-form-card { background:#fff;border-radius:18px;padding:2.25rem;box-shadow:0 4px 28px rgba(0,0,0,.07); }
.vf-card-title { font-family:'Playfair Display',serif;font-size:1.35rem;font-weight:700;color:#0b3d4a;margin:0 0 1.75rem; }

/* Fields */
.vf-row { display:grid;grid-template-columns:1fr 1fr;gap:1rem; }
.vf-fg { margin-bottom:1.1rem; }
.vf-fg label { display:block;font-size:.78rem;font-weight:600;color:#555;margin-bottom:.4rem;letter-spacing:.02em; }
.vf-fg input,.vf-fg select {
  width:100%;padding:.65rem .9rem;border:1.5px solid rgba(0,0,0,.12);border-radius:9px;
  font-family:'DM Sans',sans-serif;font-size:.9rem;color:#1a1a1a;background:#fafafa;
  transition:border-color .2s,box-shadow .2s;box-sizing:border-box;outline:none;appearance:none;
}
.vf-fg input:focus,.vf-fg select:focus { border-color:#21808d;box-shadow:0 0 0 3px rgba(33,128,141,.12);background:#fff; }
.vf-fg input:disabled,.vf-fg select:disabled { opacity:.55;cursor:not-allowed; }
.vf-sw { position:relative; }
.vf-sw::after { content:'▾';position:absolute;right:.9rem;top:50%;transform:translateY(-50%);color:#aaa;pointer-events:none;font-size:.8rem; }

/* Checkboxes */
.vf-checks { margin-bottom:1.5rem;display:flex;flex-direction:column;gap:.65rem; }
.vf-check {
  display:flex;align-items:flex-start;gap:.75rem;
  padding:.75rem 1rem;background:#f8f7f5;border-radius:10px;
  border:1.5px solid transparent;transition:border-color .2s,background .2s;
}
.vf-check:has(input:checked) { border-color:rgba(33,128,141,.3);background:rgba(33,128,141,.05); }
.vf-check input[type=checkbox] { width:17px;height:17px;accent-color:#21808d;flex-shrink:0;margin-top:1px;cursor:pointer; }
.vf-check-lbl { font-size:.88rem;color:#444;line-height:1.5;cursor:pointer; }

/* Error */
.vf-error { padding:.85rem 1rem;background:#fff3f3;border:1px solid #ffcdd2;border-radius:9px;color:#c62828;font-size:.88rem;margin-bottom:1.25rem;display:flex;align-items:flex-start;gap:.5rem; }

/* Submit */
.vf-submit {
  width:100%;padding:.8rem;
  background:linear-gradient(135deg,#0b3d4a,#21808d);
  color:#fff;border:none;border-radius:10px;
  font-family:'DM Sans',sans-serif;font-size:.97rem;font-weight:600;
  cursor:pointer;transition:transform .2s,box-shadow .2s;
  box-shadow:0 4px 16px rgba(33,128,141,.28);
  display:flex;align-items:center;justify-content:center;gap:.5rem;
}
.vf-submit:hover:not(:disabled) { transform:translateY(-2px);box-shadow:0 8px 24px rgba(33,128,141,.38); }
.vf-submit:disabled { opacity:.65;cursor:not-allowed;transform:none; }
@keyframes vfSpin { to{transform:rotate(360deg)} }
.vf-spinner { width:16px;height:16px;border-radius:50%;border:2px solid rgba(255,255,255,.4);border-top-color:#fff;animation:vfSpin .7s linear infinite;display:inline-block; }

/* Side panel */
.vf-panel { display:flex;flex-direction:column;gap:1rem; }
.vf-info-card { background:#fff;border-radius:14px;padding:1.5rem;box-shadow:0 2px 12px rgba(0,0,0,.05); }
.vf-info-title { font-family:'Playfair Display',serif;font-size:1rem;font-weight:700;color:#0b3d4a;margin:0 0 1rem; }
.vf-benefit { display:flex;align-items:flex-start;gap:.75rem;padding:.65rem 0;border-bottom:1px solid rgba(0,0,0,.06); }
.vf-benefit:last-child { border-bottom:none;padding-bottom:0; }
.vf-b-icon  { font-size:1.3rem;flex-shrink:0;margin-top:1px; }
.vf-b-title { font-size:.85rem;font-weight:600;color:#0b3d4a;margin:0 0 .15rem; }
.vf-b-desc  { font-size:.78rem;color:#888;line-height:1.5;margin:0; }
.vf-qcard { background:linear-gradient(135deg,#0b3d4a,#134d5e);border-radius:14px;padding:1.5rem;color:#fff;box-shadow:0 4px 20px rgba(11,61,74,.22); }
.vf-qmark { font-size:2rem;opacity:.4;line-height:1;display:block;margin-bottom:.5rem; }
.vf-qtext { font-family:'Playfair Display',serif;font-style:italic;font-size:.95rem;line-height:1.6;color:rgba(255,255,255,.88);margin:0 0 .75rem; }
.vf-qattr { font-size:.72rem;color:rgba(255,255,255,.45);letter-spacing:.08em; }

/* ═══ SUCCESS SCREEN ═══ */
.vf-success-page { font-family:'DM Sans',sans-serif;background:#f5f4f0;min-height:100vh; }
.vf-s-hero {
  position:relative;overflow:hidden;padding:4rem 2rem 3.5rem;
  background:linear-gradient(135deg,#0b3d4a 0%,#134d5e 55%,#1a6474 100%);
  text-align:center;
}
.vf-s-orb-a { width:400px;height:400px;background:radial-gradient(circle,#27ae60,transparent);top:-100px;right:-60px; }
.vf-s-orb-b { width:280px;height:280px;background:radial-gradient(circle,#f39c12,transparent);bottom:-60px;left:-40px; }
.vf-s-check {
  position:relative;z-index:1;
  width:88px;height:88px;border-radius:50%;
  background:linear-gradient(135deg,#27ae60,#2ecc71);
  display:flex;align-items:center;justify-content:center;
  margin:0 auto 1.5rem;font-size:2.4rem;color:#fff;
  box-shadow:0 8px 32px rgba(39,174,96,.45);
  animation:vfBounce .55s cubic-bezier(.36,.07,.19,.97) both;
}
@keyframes vfBounce { 0%{transform:scale(0);opacity:0}60%{transform:scale(1.15)}100%{transform:scale(1);opacity:1} }
.vf-s-h1 { position:relative;z-index:1;font-family:'Playfair Display',serif;font-size:clamp(1.8rem,4vw,2.6rem);font-weight:700;color:#fff;margin:0 0 .75rem;line-height:1.2; }
.vf-s-sub { position:relative;z-index:1;font-size:1rem;color:rgba(255,255,255,.7);line-height:1.7;max-width:48ch;margin:0 auto; }

.vf-s-body { max-width:760px;margin:0 auto;padding:3rem 2rem 5rem; }
.vf-s-card { background:#fff;border-radius:18px;padding:2.25rem;box-shadow:0 4px 28px rgba(0,0,0,.07);margin-bottom:1.5rem; }
.vf-s-card-title { font-family:'Playfair Display',serif;font-size:1.1rem;font-weight:700;color:#0b3d4a;margin:0 0 1.25rem; }

/* Details grid */
.vf-s-details { display:grid;grid-template-columns:1fr 1fr;gap:.85rem;margin-bottom:1.5rem; }
.vf-s-chip { background:#f5f4f0;border-radius:10px;padding:.85rem 1rem;border-left:4px solid var(--dc,#21808d); }
.vf-s-chip label { display:block;font-size:.65rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#aaa;margin-bottom:.3rem; }
.vf-s-chip span  { font-size:.9rem;font-weight:600;color:#1a1a1a; }

/* Steps */
.vf-s-divider { border:none;border-top:1px solid rgba(0,0,0,.07);margin:1.5rem 0; }
.vf-s-steps { display:flex;flex-direction:column;gap:.75rem;margin-top:.5rem; }
.vf-s-step  { display:flex;align-items:flex-start;gap:.85rem; }
.vf-s-num {
  width:28px;height:28px;border-radius:50%;flex-shrink:0;
  background:linear-gradient(135deg,#0b3d4a,#21808d);
  color:#fff;font-size:.72rem;font-weight:700;
  display:flex;align-items:center;justify-content:center;margin-top:1px;
}
.vf-s-txt { font-size:.88rem;color:#555;line-height:1.55; }

/* Quote */
.vf-s-quote { background:linear-gradient(135deg,#0b3d4a,#134d5e);border-radius:14px;padding:1.75rem;color:#fff;text-align:center;margin-bottom:1.5rem;box-shadow:0 4px 20px rgba(11,61,74,.22); }
.vf-s-qmark { font-size:2.5rem;opacity:.35;line-height:1;display:block;margin-bottom:.5rem; }
.vf-s-qtext { font-family:'Playfair Display',serif;font-style:italic;font-size:1.1rem;line-height:1.65;color:rgba(255,255,255,.9);margin:0 0 .85rem; }
.vf-s-qattr { font-size:.72rem;color:rgba(255,255,255,.45);letter-spacing:.1em;text-transform:uppercase; }

/* Reset */
.vf-reset { width:100%;padding:.8rem;background:transparent;color:#21808d;border:1.5px solid rgba(33,128,141,.3);border-radius:10px;font-family:'DM Sans',sans-serif;font-size:.95rem;font-weight:600;cursor:pointer;transition:all .2s; }
.vf-reset:hover { background:rgba(33,128,141,.06);border-color:#21808d; }

/* Responsive */
@media(max-width:860px) { .vf-grid{grid-template-columns:1fr;} .vf-body{padding:2.5rem 1.25rem 4rem;} .vf-s-body{padding:2rem 1.25rem 4rem;} }
@media(max-width:520px) { .vf-row{grid-template-columns:1fr;} .vf-hero{padding:3rem 1.25rem 2.5rem;} .vf-s-details{grid-template-columns:1fr;} }
`;

const INITIAL = { fullName:'', email:'', phone:'', city:'', interest:'', availability:'', whatsapp:false, consent:false };

const BENEFITS = [
  { icon:'🌟', title:'Be Part of Nation Building',    desc:'Join a meaningful movement creating positive change across Karnataka.' },
  { icon:'🎓', title:"Experience Education's Impact", desc:'See the transformative power of grassroots education first-hand.'      },
  { icon:'💝', title:'Find Joy in Giving',            desc:'Discover profound satisfaction through serving others selflessly.'     },
  { icon:'📜', title:'Earn Service Certification',    desc:'Get an MSME-registered certificate after completing service hours.'   },
];

export default function VolunteerForm() {
  const [formData, setFormData] = useState(INITIAL);
  const [status,   setStatus]   = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const API = process.env.REACT_APP_API_URL || 'http://localhost:5127';

  const change = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(p => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setStatus('submitting'); setErrorMsg('');
    const payload = {
      fullName:     formData.fullName.trim(),
      email:        formData.email.trim().toLowerCase(),
      phone:        formData.phone.trim(),
      city:         formData.city.trim(),
      interest:     INTEREST_MAP[formData.interest],
      availability: AVAILABILITY_MAP[formData.availability],
      whatsapp:     formData.whatsapp,
      consent:      formData.consent,
    };
    try {
      const res = await fetch(`${API}/api/Volunteers`, {
        method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload),
      });
      if (res.status === 409) { setErrorMsg('An application with this email already exists. Please use a different email or contact us directly.'); setStatus('error'); return; }
      if (!res.ok) { const d = await res.json().catch(()=>({})); throw new Error(d.error||`Server error (${res.status})`); }
      setStatus('success');
    } catch (err) { setErrorMsg(err.message||'Something went wrong. Please try again.'); setStatus('error'); }
  };

  const reset = () => { setFormData(INITIAL); setStatus('idle'); setErrorMsg(''); };

  /* ═══ SUCCESS ═══ */
  if (status === 'success') {
    const chips = [
      { label:'Name',         value: formData.fullName,                       color:'#21808d' },
      { label:'Email',        value: formData.email,                          color:'#e67e22' },
      { label:'City',         value: formData.city,                           color:'#8e44ad' },
      { label:'Interest',     value: INTEREST_MAP[formData.interest],         color:'#27ae60' },
      { label:'Availability', value: AVAILABILITY_MAP[formData.availability], color:'#21808d' },
      { label:'WhatsApp',     value: formData.whatsapp ? 'Yes — will be added' : 'No', color:'#e67e22' },
    ];
    const steps = [
      `Our team will review your application and contact you at ${formData.email}.`,
      'You will be onboarded into our volunteer network and matched to projects fitting your interest.',
      formData.whatsapp ? 'You will be added to our WhatsApp volunteer group shortly.' : 'You can request to join our WhatsApp group anytime by emailing us.',
      'After completing community service hours you will receive your MSME-registered Service Certificate.',
    ];

    return (
      <div className="vf-success-page">
        <style>{CSS}</style>
        <div className="vf-s-hero">
          <div className="vf-orb vf-s-orb-a"/><div className="vf-orb vf-s-orb-b"/>
          <div className="vf-s-check">✓</div>
          <h1 className="vf-s-h1">Application Submitted!</h1>
          <p className="vf-s-sub">
            Thank you, <strong style={{color:'#f39c12'}}>{formData.fullName}</strong>!
            We've received your application and are thrilled to have you on board.
          </p>
        </div>

        <div className="vf-s-body">
          <div className="vf-s-card">
            <p className="vf-s-card-title">Your Application Details</p>
            <div className="vf-s-details">
              {chips.map((c,i) => (
                <div key={i} className="vf-s-chip" style={{'--dc':c.color}}>
                  <label>{c.label}</label><span>{c.value}</span>
                </div>
              ))}
            </div>

            <hr className="vf-s-divider"/>
            <p className="vf-s-card-title" style={{marginBottom:'.75rem'}}>What Happens Next?</p>
            <div className="vf-s-steps">
              {steps.map((txt,i) => (
                <div key={i} className="vf-s-step">
                  <div className="vf-s-num">{i+1}</div>
                  <p className="vf-s-txt">{txt}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="vf-s-quote">
            <span className="vf-s-qmark">❝</span>
            <p className="vf-s-qtext">They alone live, who live for others.</p>
            <span className="vf-s-qattr">— Swami Vivekananda</span>
          </div>

          <button className="vf-reset" onClick={reset}>Submit Another Application</button>
        </div>
      </div>
    );
  }

  /* ═══ FORM ═══ */
  return (
    <div className="vf-page">
      <style>{CSS}</style>
      <div className="vf-hero">
        <div className="vf-orb vf-orb--a"/><div className="vf-orb vf-orb--b"/>
        <div className="vf-hero-inner">
          <div className="vf-badge"><span className="vf-bdot"/>Join the Movement · Open to All</div>
          <h1 className="vf-h1">Become a <span className="vf-gold">Volunteer</span></h1>
          <p className="vf-hero-sub">Be part of Viveka Seva's mission to educate, heal, and uplift communities across Karnataka. Takes less than 2 minutes.</p>
        </div>
      </div>

      <div className="vf-body">
        <div className="vf-grid">

          {/* FORM */}
          <div className="vf-form-card">
            <p className="vf-card-title">Your Details</p>
            {status === 'error' && <div className="vf-error"><span>⚠️</span><span>{errorMsg}</span></div>}

            <form onSubmit={submit}>
              <div className="vf-row">
                <div className="vf-fg"><label>Full Name *</label>
                  <input type="text" name="fullName" value={formData.fullName} onChange={change} placeholder="Your full name" required disabled={status==='submitting'}/></div>
                <div className="vf-fg"><label>Email *</label>
                  <input type="email" name="email" value={formData.email} onChange={change} placeholder="your@email.com" required disabled={status==='submitting'}/></div>
              </div>
              <div className="vf-row">
                <div className="vf-fg"><label>Phone Number *</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={change} placeholder="10-digit number" pattern="[0-9]{10}" required disabled={status==='submitting'}/></div>
                <div className="vf-fg"><label>City *</label>
                  <input type="text" name="city" value={formData.city} onChange={change} placeholder="Your city" required disabled={status==='submitting'}/></div>
              </div>
              <div className="vf-row">
                <div className="vf-fg"><label>Area of Interest *</label>
                  <div className="vf-sw">
                    <select name="interest" value={formData.interest} onChange={change} required disabled={status==='submitting'}>
                      <option value="">Select interest</option>
                      <option value="education">Education</option>
                      <option value="healthcare">Healthcare</option>
                      <option value="community">Community Development</option>
                      <option value="environment">Environmental</option>
                      <option value="it">IT &amp; Technology</option>
                    </select>
                  </div>
                </div>
                <div className="vf-fg"><label>Availability *</label>
                  <div className="vf-sw">
                    <select name="availability" value={formData.availability} onChange={change} required disabled={status==='submitting'}>
                      <option value="">Select availability</option>
                      <option value="weekdays">Weekdays</option>
                      <option value="weekends">Weekends</option>
                      <option value="flexible">Flexible</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="vf-checks">
                <div className="vf-check">
                  <input type="checkbox" name="whatsapp" id="whatsapp" checked={formData.whatsapp} onChange={change} disabled={status==='submitting'}/>
                  <label htmlFor="whatsapp" className="vf-check-lbl">I want to join our WhatsApp volunteer group 💬</label>
                </div>
                <div className="vf-check">
                  <input type="checkbox" name="consent" id="consent" checked={formData.consent} onChange={change} required disabled={status==='submitting'}/>
                  <label htmlFor="consent" className="vf-check-lbl">I consent to be contacted for volunteer opportunities *</label>
                </div>
              </div>

              <button type="submit" className="vf-submit" disabled={status==='submitting'}>
                {status === 'submitting' ? <><span className="vf-spinner"/>Submitting…</> : 'Submit Application →'}
              </button>
            </form>
          </div>

          {/* SIDE PANEL */}
          <div className="vf-panel">
            <div className="vf-info-card">
              <p className="vf-info-title">Why Volunteer With Us?</p>
              {BENEFITS.map((b,i) => (
                <div key={i} className="vf-benefit">
                  <span className="vf-b-icon">{b.icon}</span>
                  <div><p className="vf-b-title">{b.title}</p><p className="vf-b-desc">{b.desc}</p></div>
                </div>
              ))}
            </div>
            <div className="vf-qcard">
              <span className="vf-qmark">❝</span>
              <p className="vf-qtext">Arise, awake, and stop not until the goal is reached.</p>
              <span className="vf-qattr">— Swami Vivekananda</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}